import { isEmptyValue, clearElement, joinValues } from './LegacyModeStrategy.js';
import { IndexlistModeStrategy } from './IndexlistModeStrategy.js';

class MultipleModeStrategy {
    constructor(context, base) {
        this.context = context;
        this.base = base;
        this.mode = base.mode;
    }
    onChange() {
        if (this.base instanceof IndexlistModeStrategy)
            this.base.syncDataValueFromDisplay();
        this.context.emitComboChange();
        this.context.element.classList.remove("ui-autocomplete-loading");
    }
    onSelect(item, index) {
        const parts = this._split(this.context.element.value);
        parts.pop();
        const display = this.context.displayText(item);
        parts.push(item.value === item.key ? display : `${display} [${item.key}]`);
        parts.push("");
        this.context.element.value = parts.join(this._separator());
        if (this.base instanceof IndexlistModeStrategy)
            this.base.syncDataValueFromDisplay();
        this.context.element.classList.remove("ui-autocomplete-loading");
        this.context.emitComboChange({ item, index });
        this.context.refocusCaretToEnd();
    }
    getValue() {
        if (this.base instanceof IndexlistModeStrategy)
            return this.base.getValue();
        const value = this.context.element.value.trim();
        return value || null;
    }
    setValue(value) {
        if (this.base instanceof IndexlistModeStrategy)
            return this.base.setValue(value);
        if (isEmptyValue(value)) {
            clearElement(this.context.element);
            return true;
        }
        this.context.element.value = Array.isArray(value)
            ? joinValues(value, this.context.element, this.context.semicolon)
            : String(value).trim();
        return true;
    }
    hasValue() {
        if (this.base instanceof IndexlistModeStrategy)
            return this.base.hasValue();
        return this.context.element.value.trim() !== "";
    }
    getValueTitle() {
        if (this.base instanceof IndexlistModeStrategy)
            return this.base.getValueTitle();
        const value = this.context.element.value.trim();
        return value || null;
    }
    resolveTerm(rawValue) {
        const parts = this._split(rawValue);
        return (parts.pop() ?? "").trim();
    }
    _split(value) {
        if (this.context.element instanceof HTMLTextAreaElement) {
            return value.split("\n").map(item => item.trim());
        }
        return (this.context.semicolon ? value.split(",") : value.split(";"))
            .map(item => item.trim());
    }
    _separator() {
        if (this.context.element instanceof HTMLTextAreaElement)
            return "\n";
        return this.context.semicolon ? ", " : "; ";
    }
}

export { MultipleModeStrategy };
